import { ApiError } from './httpClient'
import { httpClient } from './httpClient'
import type { PvSizingToolRequest, PvSizingToolResponse } from '../dto/shared/PvToolDto'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '/api'

/** Separate from httpClient.post, which always expects a JSON response body - this endpoint
 *  returns application/pdf bytes (see PvToolController.exportPdf). Anonymous like the rest of the
 *  tool, so no Authorization header. */
async function downloadPdf(request: PvSizingToolRequest): Promise<Blob> {
  let response: Response
  try {
    response = await fetch(`${API_BASE_URL}/tools/pv-sizing/pdf`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(request),
    })
  } catch {
    throw new ApiError(0, 'Backend nicht erreichbar. Läuft der Server?', { path: '/tools/pv-sizing/pdf' })
  }

  if (!response.ok) {
    throw new ApiError(response.status, `PDF-Export fehlgeschlagen mit Status ${response.status}`, {
      path: '/tools/pv-sizing/pdf',
    })
  }
  return response.blob()
}

export const pvToolApi = {
  calculate: (request: PvSizingToolRequest) => httpClient.post<PvSizingToolResponse>('/tools/pv-sizing', request),
  downloadPdf,
}
